import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import Loader from '../../../components/loader';
import { renewApiToken, fetchApiToken, selectApiTokens } from './apiTokensSlice';
import ApiTokenForm from './apiTokenForm';
import Errors from '../../../components/errors';
import { useParams } from 'react-router';
import { FormMode } from './types';
import { useGetResourcesQuery } from '../../../services/roleApi';
import { useProjectsQuery } from '../../../services/projectApi';
import { useAppSelector } from '../../../app/hooks';
import { selectUser } from '../../../services/accountSlice';

const RenewApiTokenContainer: React.FC = () => {
  const { tokenId } = useParams<any>();
  const dispatch = useDispatch<any>();
  const history = useHistory();
  const { loading, token, error, saving } = useSelector(selectApiTokens);

  useEffect(() => { dispatch(fetchApiToken(tokenId)); }, [dispatch, tokenId]);
  
  const currentUser = useAppSelector(selectUser);

  const { data: resources, isLoading: resourcesIsLoading } = useGetResourcesQuery();
  const showSpecificProjects = resources?.showSpecificProjects ?? false;
  const { data: projectResponse, isLoading: projectsIsLoading } = useProjectsQuery(currentUser?.clientId ?? "", {
      skip: !currentUser?.clientId && !showSpecificProjects
    });

  const handleSave = async (name: string, expiryDate: string): Promise<boolean> => {
    try {
      const res = await dispatch(renewApiToken({ originalApiTokenId: tokenId, name, newExpiryDate: expiryDate })).unwrap();
      if (res?.success) {
        history.push('/user/api-tokens');
        return true;
      }
      return false;
    } catch (error) {
      return false;
    }
  };

  return (
    <div className="container" style={{ padding: 16 }}>
      {(loading || resourcesIsLoading || projectsIsLoading) && <Loader />}
      <h2>Renew API Token</h2>      
      <Errors error={error} />
      {token && <ApiTokenForm 
          token={token} 
          saving={saving} 
          onSave={handleSave} 
          editMode={FormMode.Renew}
          controllers={resources?.controllers} 
          projects={projectResponse?.projects} 
          showSpecificProjects={showSpecificProjects}  />}
    </div>
  );
};

export default RenewApiTokenContainer;
